/*
 * Generated type guards for "model.ts".
 * WARNING: Do not manually change this file.
 */
import { ILastOrderValidatedCartResponse, IValidateLastOrderCartRequest } from "./model";

export function isLastOrderValidatedCartResponse(obj: any, _argumentName?: string): obj is ILastOrderValidatedCartResponse {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        (obj.orderAsLastTimeValidateCart !== null &&
            typeof obj.orderAsLastTimeValidateCart === "object" ||
            typeof obj.orderAsLastTimeValidateCart === "function") &&
        (obj.orderAsLastTimeValidateCart.data !== null &&
            typeof obj.orderAsLastTimeValidateCart.data === "object" ||
            typeof obj.orderAsLastTimeValidateCart.data === "function") &&
        typeof obj.orderAsLastTimeValidateCart.data.valid === "boolean" &&
        (typeof obj.orderAsLastTimeValidateCart.data.freeDeliveryOptionFlag === "undefined" ||
            typeof obj.orderAsLastTimeValidateCart.data.freeDeliveryOptionFlag === "string") &&
        (obj.orderAsLastTimeValidateCart.data.paymentInfo !== null &&
            typeof obj.orderAsLastTimeValidateCart.data.paymentInfo === "object" ||
            typeof obj.orderAsLastTimeValidateCart.data.paymentInfo === "function") &&
        typeof obj.orderAsLastTimeValidateCart.data.paymentInfo.paymentId === "number" &&
        typeof obj.orderAsLastTimeValidateCart.data.paymentInfo.paypalTokenAvailable === "boolean" &&
        Array.isArray(obj.orderAsLastTimeValidateCart.data.paymentInfo.paymentGroups) &&
        obj.orderAsLastTimeValidateCart.data.paymentInfo.paymentGroups.every((e: any) =>
            typeof e === "string"
        ) &&
        (obj.orderAsLastTimeValidateCart.data.cart !== null &&
            typeof obj.orderAsLastTimeValidateCart.data.cart === "object" ||
            typeof obj.orderAsLastTimeValidateCart.data.cart === "function") &&
        typeof obj.orderAsLastTimeValidateCart.data.cart.cartId === "string" &&
        (obj.orderAsLastTimeValidateCart.data.cart.pricesSummary !== null &&
            typeof obj.orderAsLastTimeValidateCart.data.cart.pricesSummary === "object" ||
            typeof obj.orderAsLastTimeValidateCart.data.cart.pricesSummary === "function") &&
        typeof obj.orderAsLastTimeValidateCart.data.cart.pricesSummary.vat === "number" &&
        typeof obj.orderAsLastTimeValidateCart.data.cart.pricesSummary.priceItemSummary === "number" &&
        typeof obj.orderAsLastTimeValidateCart.data.cart.pricesSummary.pricePayment === "number" &&
        typeof obj.orderAsLastTimeValidateCart.data.cart.pricesSummary.priceDelivery === "number" &&
        typeof obj.orderAsLastTimeValidateCart.data.cart.pricesSummary.priceProductsSummary === "number" &&
        typeof obj.orderAsLastTimeValidateCart.data.cart.pricesSummary.discountWithoutDelivery === "number"
    )
}

export function isValidateLastOrderCartRequest(obj: any, _argumentName?: string): obj is IValidateLastOrderCartRequest {
    return (
        (obj !== null &&
            typeof obj === "object" ||
            typeof obj === "function") &&
        typeof obj.sameDeliveryAndInvoice === "boolean" &&
        (obj.deliveryAddress !== null &&
            typeof obj.deliveryAddress === "object" ||
            typeof obj.deliveryAddress === "function") &&
        typeof obj.deliveryAddress.company === "string" &&
        typeof obj.deliveryAddress.firstName === "string" &&
        typeof obj.deliveryAddress.lastName === "string" &&
        typeof obj.deliveryAddress.secondName === "string" &&
        typeof obj.deliveryAddress.street === "string" &&
        typeof obj.deliveryAddress.city === "string" &&
        typeof obj.deliveryAddress.zipCode === "string" &&
        typeof obj.deliveryAddress.region === "string" &&
        typeof obj.deliveryAddress.district === "string" &&
        typeof obj.deliveryAddress.flatNumber === "string" &&
        typeof obj.deliveryAddress.email === "string" &&
        typeof obj.deliveryAddress.phone === "string" &&
        typeof obj.deliveryAddress.streetType === "number" &&
        typeof obj.deliveryAddress.streetNumber === "string" &&
        typeof obj.deliveryAddress.neighborhood === "string" &&
        typeof obj.deliveryAddress.blockNo === "string" &&
        typeof obj.deliveryAddress.entrance === "string" &&
        typeof obj.deliveryAddress.districtType === "number" &&
        typeof obj.deliveryAddress.floor === "number" &&
        typeof obj.deliveryAddress.province === "string" &&
        typeof obj.deliveryAddress.info === "string" &&
        typeof obj.deliveryAddress.note === "string" &&
        typeof obj.deliveryAddress.countryId === "string" &&
        (obj.invoiceAddress !== null &&
            typeof obj.invoiceAddress === "object" ||
            typeof obj.invoiceAddress === "function") &&
        typeof obj.invoiceAddress.company === "string" &&
        typeof obj.invoiceAddress.firstName === "string" &&
        typeof obj.invoiceAddress.lastName === "string" &&
        typeof obj.invoiceAddress.secondName === "string" &&
        typeof obj.invoiceAddress.street === "string" &&
        typeof obj.invoiceAddress.city === "string" &&
        typeof obj.invoiceAddress.zipCode === "string" &&
        typeof obj.invoiceAddress.region === "string" &&
        typeof obj.invoiceAddress.district === "string" &&
        typeof obj.invoiceAddress.flatNumber === "string" &&
        typeof obj.invoiceAddress.email === "string" &&
        typeof obj.invoiceAddress.phone === "string" &&
        typeof obj.invoiceAddress.streetType === "number" &&
        typeof obj.invoiceAddress.streetNumber === "string" &&
        typeof obj.invoiceAddress.neighborhood === "string" &&
        typeof obj.invoiceAddress.blockNo === "string" &&
        typeof obj.invoiceAddress.entrance === "string" &&
        typeof obj.invoiceAddress.districtType === "number" &&
        typeof obj.invoiceAddress.floor === "number" &&
        typeof obj.invoiceAddress.province === "string" &&
        typeof obj.invoiceAddress.info === "string" &&
        typeof obj.invoiceAddress.note === "string" &&
        typeof obj.invoiceAddress.countryId === "string" &&
        typeof obj.invoiceAddress.cin === "string" &&
        typeof obj.invoiceAddress.tin === "string" &&
        (obj.invoiceAddress.companyIdentificationData !== null &&
            typeof obj.invoiceAddress.companyIdentificationData === "object" ||
            typeof obj.invoiceAddress.companyIdentificationData === "function") &&
        typeof obj.invoiceAddress.companyIdentificationData.companyRegistrationNumber === "string" &&
        typeof obj.invoiceAddress.companyIdentificationData.recipientCode === "string" &&
        typeof obj.invoiceAddress.companyIdentificationData.pecCode === "string" &&
        typeof obj.invoiceAddress.personalIdentificationNumber === "string" &&
        (obj.deliveryInfo !== null &&
            typeof obj.deliveryInfo === "object" ||
            typeof obj.deliveryInfo === "function") &&
        typeof obj.deliveryInfo.isPersonalPickup === "boolean" &&
        typeof obj.deliveryInfo.deliveryTypeId === "number" &&
        typeof obj.deliveryInfo.deliveryName === "string" &&
        typeof obj.deliveryInfo.deliveryPrice === "number" &&
        obj.deliveryInfo.deliveryTime instanceof Date &&
        (obj.deliveryInfo.distributionPoint !== null &&
            typeof obj.deliveryInfo.distributionPoint === "object" ||
            typeof obj.deliveryInfo.distributionPoint === "function") &&
        typeof obj.deliveryInfo.distributionPoint.noAddressForPersonalPickup === "boolean" &&
        typeof obj.deliveryInfo.distributionPoint.distributionPointId === "string" &&
        (obj.paymentInfo !== null &&
            typeof obj.paymentInfo === "object" ||
            typeof obj.paymentInfo === "function") &&
        (typeof obj.paymentInfo.paypalTokenAvailable === "undefined" ||
            obj.paymentInfo.paypalTokenAvailable === false ||
            obj.paymentInfo.paypalTokenAvailable === true) &&
        typeof obj.paymentInfo.paymentType === "number" &&
        typeof obj.paymentInfo.paymentPrice === "number" &&
        typeof obj.paymentInfo.paymentName === "string" &&
        typeof obj.paymentInfo.providerType === "string" &&
        Array.isArray(obj.paymentInfo.paymentGroups) &&
        obj.paymentInfo.paymentGroups.every((e: any) =>
            typeof e === "string"
        )
    )
}
